export function formatBreadcrumb(segment: string) {
  if (!segment) return "";

  // e.g. generic-course -> Generic Course
  return segment.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
}
